<template>
  <div>
    <router-view></router-view>
    <BottomSheet></BottomSheet>
  </div>
</template>

<script>

import BottomSheet from '../BottomSheet';
import ListDataEditor from '../content/ListDataEditor';
import ContractsList from './ContractsList'

export default {
  name: "ContractsPage",
  components: {
    BottomSheet
  },
  routes: [
    {
      path: "",
      redirect: "/billing/contracts/list"
    },
    {      
      path: "list",
      components: {
        default: ContractsList,
      },
      name: "Billing contracts list",
    },
    {
      path: "list/:id/data/new",
      components: {
        default: ContractsList,
        bottomEditor: ListDataEditor
      },
      props: {
        default: true,
        bottomEditor: true
      },
      name: "Billing contracts new"
    },
    {
      path: "list/:id/data/edit/:data_id",
      components: {
        default: ContractsList,
        bottomEditor: ListDataEditor
      },
      props: {
        default: true,
        bottomEditor: true
      },
      name: "Billing contracts edit"
    },
   
  ]
}
</script>